import { dna24ProfileAtom } from 'dataLayer/recoil/apiData/atoms';
import {
  getAllTraits,
  getAllTraitsWithLimit,
  getFilteredSectionTraits,
  getSectionTraits,
  mapTraits,
} from 'dataLayer/recoil/pages/helpers/traitHelpers';
import {
  getSectionTips,
  mapTips,
} from 'dataLayer/recoil/pages/helpers/tipsHelper';
import { selector } from 'recoil';

export const allTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/allTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const allTraits = getAllTraits(dna24Profile);
    const mappedTraits = mapTraits(allTraits);

    return mappedTraits;
  },
});

export const eatFreshTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/eatFreshTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const eatFreshTraits = getFilteredSectionTraits('eat_fresh', dna24Profile);
    const mappedTraits = mapTraits(eatFreshTraits);
    return mappedTraits;
  },
});

export const stayActiveTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/stayActiveTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const stayActiveTraits = getFilteredSectionTraits(
      'stay_active',
      dna24Profile
    );
    const mappedTraits = mapTraits(stayActiveTraits);

    return mappedTraits;
  },
});

export const skinTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/skinTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const skinTraits = getFilteredSectionTraits('skin', dna24Profile);
    const mappedTraits = mapTraits(skinTraits);

    return mappedTraits;
  },
});

export const allergyTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/allergyTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const allergyTraits = getFilteredSectionTraits('allergy', dna24Profile);
    const mappedTraits = mapTraits(allergyTraits);

    return mappedTraits;
  },
});

export const hairTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/hairTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const hairTraits = getFilteredSectionTraits('hair', dna24Profile);
    const mappedTraits = mapTraits(hairTraits);

    return mappedTraits;
  },
});

export const beProductiveTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/beProductiveTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const beProductiveTraits = getFilteredSectionTraits(
      'be_productive',
      dna24Profile
    );
    const mappedTraits = mapTraits(beProductiveTraits);

    return mappedTraits;
  },
});

export const allEatFreshTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/allEatFreshTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const eatFreshTraits = getSectionTraits('eat_fresh', dna24Profile);
    const mappedTraits = mapTraits(eatFreshTraits);
    return mappedTraits;
  },
});

export const allStayActiveTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/allStayActiveTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const stayActiveTraits = getSectionTraits('stay_active', dna24Profile);
    const mappedTraits = mapTraits(stayActiveTraits);

    return mappedTraits;
  },
});

export const allBeProductiveTraitsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/allBeProductiveTraits',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const beProductiveTraits = getSectionTraits('be_productive', dna24Profile);
    const mappedTraits = mapTraits(beProductiveTraits);

    return mappedTraits;
  },
});

export const eatFreshTipsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/eatFreshTips',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const eatFreshTips = getSectionTips('eat_fresh', dna24Profile);
    const mappedTips = mapTips(eatFreshTips);

    return mappedTips;
  },
});

export const stayActiveTipsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/stayActiveTips',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const stayActiveTips = getSectionTips('stay_active', dna24Profile);
    const mappedTips = mapTips(stayActiveTips);

    return mappedTips;
  },
});

export const beProductiveTipsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/beProductiveTips',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const beProductiveTips = getSectionTips('be_productive', dna24Profile);
    const mappedTips = mapTips(beProductiveTips);

    return mappedTips;
  },
});

export const restAndRejuvenateTipsDefaultSelector = selector({
  key: 'apiData/pages/sections/defaultSelectors/restAndRejuvenateTips',
  get: ({ get }) => {
    let dna24Profile = get(dna24ProfileAtom);
    const restAndRejuvenateTips = getSectionTips('be_productive', dna24Profile);
    const mappedTips = mapTips(restAndRejuvenateTips);

    return mappedTips;
  },
});
